export enum RegenerativePlotType {
  FIELD = 'field',
  PARCEL = 'parcel',
}
